import(/* webpackMode: "eager" */ "/home/runner/work/monorepo/monorepo/frontend/src/app/login/page.tsx");
